<template lang="pug">
  section#sidebar
    .logo-wrapper(v-if="logo && logo.id")
      img#sb-logo(v-lazy="image" title="logo" rel="noopener")
    Menu#sb-main-menu(k="main-menu" :max-depth="3")
    Menu#sb-header-menu(k="header-menu" :max-depth="1")
    Menu#sb-footer-menu(k="footer-menu" :max-depth="1")
</template>

<script>
import { trim } from '@/helpers';
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';

export default {
    name: 'Sidebar',
    components: {
        Menu
    },
    computed: {
        image() {
            let storageRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`;
            storageRoute = trim(storageRoute, '/');

            const fit = 'fit=fill&w=350&h=150';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            loaded: 'loaded',
            error: 'error'
        })
    },
    mounted() {
        this.$emit('mounted');
    }
};
</script>

<style lang="sass" scoped>
section#sidebar
  background-color: #1D1F20
  background-image: linear-gradient(145deg, #1D1F20, #404348)

  ::v-deep nav
    ul.tree-menu
      li
        // &.visible
        & > ul
          &.tree-menu
            border-left: 3px solid rgba(255, 255, 255, .1)
            margin-left: 22px
        a
          padding: 10px 20px
          display: block
          color: #ffffff
          &:hover
            background-color: rgba(255, 255, 255, 0.1)
        .tree-item
          display: flex
          & > a
            flex-grow: 1
          & > button
            width: 40px
            background: transparent
            border: none
            outline: none
            color: white
            font-size: 1rem
            & > i
              font-family: "Font Awesome 5 Free"
              font-weight: 900
              text-decoration: none
              font-style: normal
              &.is-closed:before
                content: "\f078"
              &.is-open:before
                content: "\f077"
            &.search-item
              margin-left: 1.2rem
              height: 2rem
              width: 2rem
              margin-top: 0.6rem
              margin-right: -0.6rem
      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
        transform-origin: left center
        max-height: 500px
        overflow: hidden
      .show-enter, .show-leave-to
        opacity: 0
        max-height: 0
        transform: translateX(-15px)
</style>
